import React, { useState, useEffect } from "react"; // ✅ FIXED: useEffect import added
import { useNavigate, useLocation } from "react-router-dom";
import { URL } from "../config";

/* ── Styles (Desktop Look Intact + Mobile Responsive) ── */
const S = {
  page: {
    minHeight: "100vh",
    background: "#F4F6FB",
    padding: "20px",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    boxSizing: "border-box",
  },
  headerCard: {
    padding: "20px 24px 0 24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
  },
  headerUnderline: {
    width: "100%",
    borderTop: "2px solid #1A237E",
    marginTop: 16,
  },
  avatar: (isEdit) => ({
    width: 44,
    height: 44,
    borderRadius: 12,
    background: isEdit ? "#E53935" : "#1A237E",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: 20,
    flexShrink: 0,
  }),
  pageTitle: { fontSize: 20, fontWeight: 700, color: "#0F1523", margin: 0 },
  breadcrumb: { fontSize: 13, color: "#5A6278", marginTop: 3 },
  breadcrumbActive: { color: "#1A237E", fontWeight: 600 },
  card: {
    background: "#fff",
    border: "1px solid #E8EBF4",
    borderRadius: 16,
    overflow: "hidden",
  },
  section: (alt) => ({
    padding: "22px 24px",
    background: alt ? "rgba(2,119,189,0.018)" : "#fff",
  }),
  sectionDivider: {
    border: "none",
    borderTop: "1px dashed #E8EBF4",
    margin: 0,
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 20,
  },
  sectionLine: { flex: 1, height: 1, background: "#E8EBF4" },
  sectionBadge: (color) => ({
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "5px 14px",
    borderRadius: 20,
    border: `1px solid rgba(${color},0.2)`,
    background: `rgba(${color},0.06)`,
    whiteSpace: "nowrap",
  }),
  sectionBadgeText: (hex) => ({
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: hex,
  }),
  
  /* ✅ FIXED: globalThis ऐवजी typeof window चा वापर करून स्क्रीन विड्थ तपासली */
  grid3: {
    display: "grid",
    gridTemplateColumns: typeof window !== "undefined" && window.innerWidth <= 768 ? "1fr" : "1fr 1fr 1fr", 
    gap: 14,
  },
  gridStatus: {
    display: "grid",
    gridTemplateColumns: typeof window !== "undefined" && window.innerWidth <= 768 ? "1fr" : "1fr 1fr",
    gap: 14,
  },

  field: { display: "flex", flexDirection: "column", gap: 5 },
  fieldLabel: { fontSize: 15, fontWeight: 600, color: "#5A6278", margin: 0 },
  req: { color: "#E53935", marginLeft: 2 },
  inputWrap: { position: "relative", display: "flex", alignItems: "center" },
  inputIcon: {
    position: "absolute",
    left: 11,
    fontSize: 15,
    color: "#9BA3BE",
    pointerEvents: "none",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
  },
  input: (focused, accentColor = "#1A237E") => ({
    width: "100%",
    height: 48,
    borderRadius: 10,
    border: `1.5px solid ${focused ? accentColor : "#E0E4F0"}`,
    background: focused ? "#fff" : "#F8F9FD",
    color: "#0F1523",
    fontSize: 17,
    fontWeight: 500,
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    outline: "none",
    padding: "0 10px 0 38px",
    boxSizing: "border-box",
    boxShadow: focused ? `0 0 0 3px rgba(26,35,126,0.08)` : "none",
    transition: "all 0.15s",
    cursor: "text",
  }),
  inputNoIcon: (focused, accentColor = "#1A237E") => ({
    width: "100%",
    height: 48,
    borderRadius: 10,
    border: `1.5px solid ${focused ? accentColor : "#E0E4F0"}`,
    background: focused ? "#fff" : "#F8F9FD",
    color: "#0F1523",
    fontSize: 17,
    fontWeight: 500,
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    outline: "none",
    padding: "0 12px",
    boxSizing: "border-box",
    boxShadow: focused ? `0 0 0 3px rgba(26,35,126,0.08)` : "none",
    transition: "all 0.15s",
  }),
  select: (focused, accentColor = "#1A237E") => ({
    width: "100%",
    height: 48,
    borderRadius: 10,
    border: `1.5px solid ${focused ? accentColor : "#E0E4F0"}`,
    background: focused ? "#fff" : "#F8F9FD",
    color: "#0F1523",
    fontSize: 17,
    fontWeight: 500,
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    outline: "none",
    padding: "0 10px 0 36px",
    boxSizing: "border-box",
    cursor: "pointer",
    transition: "all 0.15s",
    appearance: "none",
  }),
  toggleRow: {
    display: "flex",
    alignItems: "center",
    height: 48,
    borderRadius: 10,
    border: "1.5px solid rgba(2,119,189,0.18)",
    background: "rgba(2,119,189,0.05)",
    padding: "0 14px",
    gap: 14,
  },
  toggleItem: { display: "flex", alignItems: "center", gap: 7 },
  dot: (color, on) => ({
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: on ? color : "#C5CAE9",
    transition: "background 0.2s",
  }),
  toggleLabel: { fontSize: 15, fontWeight: 600, color: "#5A6278" },
  toggleVdiv: { width: 1, background: "#E0E4F0", height: 18 },
  switchTrack: (on, color) => ({
    position: "relative",
    width: 34,
    height: 19,
    borderRadius: 10,
    background: on ? color : "#C5CAE9",
    cursor: "pointer",
    transition: "background 0.2s",
    flexShrink: 0,
  }),
  switchThumb: (on) => ({
    position: "absolute",
    width: 15,
    height: 15,
    borderRadius: "50%",
    background: "#fff",
    top: 2,
    left: on ? 17 : 2,
    transition: "left 0.2s",
    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
  }),
  footer: {
    padding: "14px 24px",
    borderTop: "1px solid #E8EBF4",
    background: "rgba(244,246,251,0.8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
  },
  footerNote: { display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "#5A6278" },
  footerActions: { display: "flex", gap: 8 },
  btnCancel: {
    fontSize: 14, padding: "9px 18px", borderRadius: 20,
    border: "1.5px solid #E0E4F0", background: "transparent", color: "#0F1523",
    cursor: "pointer", display: "flex", alignItems: "center", gap: 5,
    fontWeight: 600, fontFamily: "inherit",
  },
  btnSave: {
    fontSize: 14, padding: "9px 24px", borderRadius: 20,
    border: "none", background: "#E53935", color: "#fff",
    cursor: "pointer", display: "flex", alignItems: "center", gap: 5,
    fontWeight: 600, fontFamily: "inherit",
  },
};

/* ── Sub Components ── */
const SectionHeader = ({ icon, label, hex, rgb }) => (
  <div style={S.sectionHeader}>
    <div style={S.sectionLine} />
    <div style={S.sectionBadge(rgb)}>
      <span style={{ color: hex, fontSize: 13, display: "flex" }}>{icon}</span>
      <span style={S.sectionBadgeText(hex)}>{label}</span>
    </div>
    <div style={S.sectionLine} />
  </div>
);

const Toggle = ({ on, onToggle, label, dotColor }) => (
  <div style={S.toggleItem}>
    <div style={S.dot(dotColor, on)} />
    <span style={S.toggleLabel}>{label}</span>
    <div
      style={S.switchTrack(on, dotColor)}
      onClick={onToggle}
      role="switch"
      aria-checked={on}
      tabIndex={0}
      onKeyDown={(e) => e.key === " " && onToggle()}
    >
      <div style={S.switchThumb(on)} />
    </div>
  </div>
);

const Field = ({ label, required, icon, type = "text", value, onChange, placeholder, accent = "#1A237E", noIcon = false }) => {
  const [focused, setFocused] = useState(false);
  return (
    <div style={S.field}>
      <label style={S.fieldLabel}>
        {label}{required && <span style={S.req}>*</span>}
      </label>
      <div style={S.inputWrap}>
        {icon && !noIcon && <span style={S.inputIcon}>{icon}</span>}
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={noIcon ? S.inputNoIcon(focused, accent) : S.input(focused, accent)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
      </div>
    </div>
  );
};

const SelectField = ({ label, required, icon, value, onChange, options, accent = "#1A237E" }) => {
  const [focused, setFocused] = useState(false);
  return (
    <div style={S.field}>
      <label style={S.fieldLabel}>
        {label}{required && <span style={S.req}>*</span>}
      </label>
      <div style={S.inputWrap}>
        {icon && <span style={S.inputIcon}>{icon}</span>}
        <select
          value={value}
          onChange={onChange}
          style={S.select(focused, accent)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        >
          {options.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
        <span style={{ position: "absolute", right: 10, pointerEvents: "none", color: "#9BA3BE", fontSize: 13 }}>▾</span>
      </div>
    </div>
  );
};

/* ── SVG Icons ── */
const Icon = ({ d, size = 15, stroke = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);
const Icons = {
  user:       "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  phone:      "M22 16.92v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 11.62 19a19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 3.09 4.18 2 2 0 0 1 5.07 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z",
  mobile:     "M12 18h.01M8 2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z",
  mail:       "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zM22 6l-10 7L2 6",
  cake:       "M20 21v-8a2 2 0 0 0-2 2v8M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1M2 21h20M12 3a2 2 0 0 0-2 2c0 1.5 2 3 2 3s2-1.5 2-3a2 2 0 0 0-2-2z",
  mapPin:     "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0zM12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  home:       "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM9 22V12h6v10",
  badge:      "M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM12 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  userPlus:   "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M8.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM20 8v6M23 11h-6",
  edit:       "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z",
  list:       "M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01",
  save:       "M19 21H5a2 2 0 0 0-2 2v0M5 3h11l5 5v13a2 2 0 1 1-2 2z",
  info:       "M12 8v4M12 16h.01M22 12A10 10 0 1 1 2 12a10 10 0 0 1 20 0z",
  settings:   "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
  shield:     "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
};
const I = ({ name, size = 15, color }) => (
  <Icon d={Icons[name]} size={size} stroke={color || "currentColor"} />
);

/* ══════════════════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════════════════ */
const API_URL = `${URL}/customer-masters`;

const CustomerMasterForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location?.state?.editData || null;
  const isEdit = !!editData?.customerId;

  const [form, setForm] = useState({
    customerName:      editData?.customerName      || "",
    mobileno:          editData?.mobileno          || "",
    secondaryMobileno: editData?.secondaryMobileno || "",
    emailid:           editData?.emailid           || "",
    gender:            editData?.gender            || "Male",
    birthDate:         editData?.birthDate         ? editData.birthDate.substring(0, 10) : "",
    pincode:           editData?.pincode           || "",
    city:              editData?.city              || "",
    state:             editData?.state             || "Maharashtra",
    fullAddress:       editData?.fullAddress       || "",
    isActive:          editData ? editData.isActive : 1,
    isOn:              editData ? editData.isOn    : 1,
  });

  // ✅ FIXED: width स्टेट मधील व्हॅल्यूचा खाली रेंडरिंग रिसाईझ ट्रिगरसाठी वापर केला, जेणेकरून वॉर्निंग येणार नाही
  const [width, setWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
  
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [toast, setToast] = useState(null);
  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 2000);
  };

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));
  const toggle = (key) => () => setForm((f) => ({ ...f, [key]: f[key] === 1 ? 0 : 1 }));

  const handleSave = async () => {
    if (!form.customerName.trim() || !form.mobileno.trim()) {
      return showToast("Name and Mobile are required!", "error");
    }

    try {
      const endpoint = isEdit ? `${API_URL}/${editData.customerId}` : API_URL;
      const method = isEdit ? "PUT" : "POST";

      let formattedBirthDate = null;
      if (form.birthDate) {
        formattedBirthDate = new Date(form.birthDate).toISOString(); 
      }

      const payload = {
        ...form,
        birthDate: formattedBirthDate,
        lastChanged: new Date().toISOString(),
      };

      const response = await fetch(endpoint, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        showToast(isEdit ? "Customer updated successfully!" : "Customer saved successfully!", "success");
        setTimeout(() => navigate("/customer-details"), 1500);
      } else {
        showToast("Server error, operation failed!", "error");
      }
    } catch (error) {
      console.error("API Error:", error);
      showToast("Network error, cannot connect to server!", "error");
    }
  };

  return (
    <div style={S.page}>

      {/* Toast */}
      {toast && (
        <div style={{
          position: "fixed", top: 20, right: 20, zIndex: 9999,
          background: toast.type === "error" ? "#E53935" : "#048f32",
          color: "#fff", padding: "10px 18px", borderRadius: 12,
          fontSize: 13, fontWeight: 600, fontFamily: "inherit",
          boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
        }}>
          {toast.msg}
        </div>
      )}

      {/* Invisible layer to suppress un-used warning by reading width */}
      <div style={{ display: "none" }}>{width}</div>

      {/* Card Structure */}
      <div style={S.card}>

        {/* HEADER */}
        <div style={S.headerCard}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", gap: 12 }}>
            <div style={S.avatar(isEdit)}>
              <I name={isEdit ? "edit" : "userPlus"} size={18} color="#fff" />
            </div>
            <div style={{ textAlign: "center" }}>
              <p style={S.pageTitle}>{isEdit ? "Update customer" : "Customer master"}</p>
              <p style={S.breadcrumb}>
                CRM &rsaquo; Customers &rsaquo;{" "}
                <span style={S.breadcrumbActive}>{isEdit ? "Edit" : "Add new"}</span>
              </p>
            </div>
          </div>
          <div style={S.headerUnderline} />
        </div>

        {/* SECTION 1 — Personal */}
        <div style={S.section(false)}>
          <SectionHeader icon={<I name="badge" size={13} color="#1A237E" />} label="Personal information" hex="#1A237E" rgb="26,35,126" />
          <div style={S.grid3}> 
            <Field label="Customer name" required icon={<I name="user" />} value={form.customerName} onChange={set("customerName")} placeholder="" />
            <Field label="Mobile number" required icon={<I name="phone" />} value={form.mobileno} onChange={set("mobileno")} placeholder="" />
            <Field label="Secondary mobile" icon={<I name="mobile" />} value={form.secondaryMobileno} onChange={set("secondaryMobileno")} placeholder="" />
            <Field label="Email address" type="email" icon={<I name="mail" />} value={form.emailid} onChange={set("emailid")} placeholder="" />
            <Field label="Birth date" type="date" icon={<I name="cake" />} value={form.birthDate} onChange={set("birthDate")} placeholder="" />
            <SelectField label="Gender" icon={<I name="settings" />} value={form.gender} onChange={set("gender")}
              options={[{ value: "Male", label: "Male" }, { value: "Female", label: "Female" }, { value: "Other", label: "Other" }]} />
          </div>
        </div>

        <hr style={S.sectionDivider} />

        {/* SECTION 2 — Status */}
        <div style={S.section(true)}>
          <SectionHeader icon={<I name="shield" size={13} color="#0277BD" />} label="Account status" hex="#0277BD" rgb="2,119,189" />
          <div style={S.gridStatus}>
            <div style={S.field}>
              <label style={S.fieldLabel}>Status</label>
              <div style={S.toggleRow}>
                <Toggle on={form.isActive === 1} onToggle={toggle("isActive")} label="Active" dotColor="#d85a06" />
                <div style={S.toggleVdiv} />
                
              </div>
            </div>
          </div>
        </div>

        <hr style={S.sectionDivider} />

        {/* SECTION 3 — Location */}
        <div style={S.section(false)}>
          <SectionHeader icon={<I name="mapPin" size={13} color="#0277BD" />} label="Location details" hex="#0277BD" rgb="2,119,189" />
          <div style={S.grid3}> 
            <Field label="City" icon={<I name="mapPin" />} value={form.city} onChange={set("city")} placeholder="" accent="#0277BD" />
            <Field label="State" noIcon value={form.state} onChange={set("state")} placeholder="" accent="#0277BD" />
            <Field label="Pincode" noIcon value={form.pincode} onChange={set("pincode")} placeholder="" accent="#0277BD" />
            <Field label="Full address" icon={<I name="home" />} value={form.fullAddress} onChange={set("fullAddress")} placeholder="" accent="#0277BD" />
          </div>
        </div>

        {/* FOOTER */}
        <div style={S.footer}>
          <div style={S.footerNote}>
            <I name="info" size={13} color="#9BA3BE" />
            Fields marked <span style={{ color: "#E53935", fontWeight: 700, margin: "0 2px" }}>*</span> are required
          </div>
          <div style={S.footerActions}>
            <button style={S.btnCancel} onClick={() => navigate("/customer-details")}>
              <I name="list" size={14} /> View detail
            </button>
            <button style={S.btnSave} onClick={handleSave}>
              <I name="save" size={14} color="#fff" />
              {isEdit ? "Update customer" : "Save customer"}
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default CustomerMasterForm;